import { useState } from "react";
import { Link } from "react-router-dom";

const LegalLayout = ({ children, activePage }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinkStyle = (page) => ({
    color: activePage === page ? "#4318FF" : "#374151",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: activePage === page ? 700 : 500,
  });

  return (
    <div style={{ minHeight: "100vh", background: "#f4f7fe", fontFamily: "Arial, sans-serif", overflowX: "hidden" }}>

      {/* Navbar */}
      <nav style={{
        background: "#fff",
        padding: "14px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
        position: "sticky",
        top: 0,
        zIndex: 100,
        flexWrap: "wrap",
        gap: 8,
      }}>
        <a href="/" style={{ fontSize: 18, fontWeight: 800, color: "#4318FF", textDecoration: "none", display: "flex", alignItems: "center", gap: 8 }}>
          🚗 FraudCheck FDS
        </a>

        {/* Desktop links */}
        <ul style={{ display: "flex", alignItems: "center", gap: 20, listStyle: "none", margin: 0, padding: 0, flexWrap: "wrap" }}
          className="legal-nav-links">
          <li><a href="/about"         style={navLinkStyle("about")}>About</a></li>
          <li><a href="/terms"         style={navLinkStyle("terms")}>Terms</a></li>
          <li><a href="/privacy"       style={navLinkStyle("privacy")}>Privacy</a></li>
          <li><a href="/refund-policy" style={navLinkStyle("refund")}>Refund Policy</a></li>
          <li>
            <a href="/" style={{
              background: "#4318FF", color: "#fff", border: "none",
              borderRadius: 8, padding: "8px 18px", fontSize: 13,
              fontWeight: 700, cursor: "pointer", textDecoration: "none",
            }}>Login</a>
          </li>
        </ul>
      </nav>

      {/* Page content */}
      <div style={{ maxWidth: "100%", overflowX: "hidden" }}>
        {children}
      </div>

    </div>
  );
};

export const legalStyles = {
  hero: {
    background: "linear-gradient(135deg, #4318FF, #7551FF)",
    color: "#fff",
    padding: "48px 20px",
    textAlign: "center",
  },
  heroTitle: { fontSize: 28, fontWeight: 800, margin: "0 0 14px 0" },
  heroSubtitle: { fontSize: 16, fontWeight: 400, margin: 0, opacity: 0.9, maxWidth: 600, marginLeft: "auto", marginRight: "auto", lineHeight: 1.6 },
  content: { maxWidth: 800, margin: "0 auto", padding: "32px 16px" },
  card: { background: "#fff", borderRadius: 16, padding: "20px 24px", marginBottom: 20, boxShadow: "0 2px 10px rgba(0,0,0,0.06)" },
  sectionHeading: { fontSize: 16, fontWeight: 800, color: "#1b2559", marginBottom: 12, marginTop: 0 },
  bodyText: { fontSize: 14, color: "#374151", lineHeight: 2, margin: 0 },
  footer: { background: "#1b2559", color: "#fff", padding: "28px 20px", textAlign: "center" },
  footerLinks: { display: "flex", justifyContent: "center", gap: 20, marginBottom: 16, flexWrap: "wrap" },
  footerLink: { color: "#a0aec0", textDecoration: "none", fontSize: 13 },
  footerText: { fontSize: 13, color: "#a0aec0", margin: "4px 0" },
};

export const LegalFooter = () => (
  <footer style={legalStyles.footer}>
    <div style={legalStyles.footerLinks}>
      <a href="/about"         style={legalStyles.footerLink}>About Us</a>
      <a href="/terms"         style={legalStyles.footerLink}>Terms & Conditions</a>
      <a href="/privacy"       style={legalStyles.footerLink}>Privacy Policy</a>
      <a href="/refund-policy" style={legalStyles.footerLink}>Refund Policy</a>
    </div>
    <p style={legalStyles.footerText}>🚗 FraudCheck FDS — India's Trusted Fraud Prevention Network for Self-Drive Car Rentals</p>
    <p style={legalStyles.footerText}>📧 admin.umasankar@gmail.com &nbsp;|&nbsp; 📞 7207270218 &nbsp;|&nbsp; 🌐 fds.uvars.com</p>
    <p style={{ ...legalStyles.footerText, marginTop: 12, fontWeight: 600, color: "#cbd5e1" }}>Uvars OPC Private Limited</p>
    <p style={{ ...legalStyles.footerText, marginTop: 4 }}>&copy; {new Date().getFullYear()} All rights reserved. Governed by the Laws of India.</p>
  </footer>
);

export default LegalLayout;
